import { BRAZIL_STATE_SHAPES, MAP_VIEWBOX } from '@/data/brazilGeo';
import { locate } from '@/lib/geo';

/** Mapa estático compacto destacando um estado e a cidade (perfil / oportunidade). */
export const MiniStateMap = ({ uf, city }) => {
  const p = city ? locate(uf, city) : null;
  return (
    <div className="relative overflow-hidden rounded-lg border border-white/10 bg-[#080b10]">
      <div className="absolute inset-0 grid-floor opacity-40" />
      <svg viewBox={MAP_VIEWBOX} className="relative mx-auto block aspect-square w-full max-w-[260px]" aria-label={`Localização: ${city || ''} ${uf}`} role="img">
        {BRAZIL_STATE_SHAPES.map((s) => (
          <path key={s.uf} d={s.d} fill={s.uf === uf ? 'rgba(34,211,238,0.28)' : 'rgba(255,255,255,0.03)'} stroke={s.uf === uf ? '#67e8f9' : 'rgba(148,220,255,0.18)'} strokeWidth={s.uf === uf ? 2 : 1} />
        ))}
        {p && (
          <>
            <circle cx={p.x} cy={p.y} r="16" fill="rgba(34,211,238,0.3)" className="marker-pulse" />
            <circle cx={p.x} cy={p.y} r="7" fill="#e0fbff" stroke="#22d3ee" strokeWidth="3" />
          </>
        )}
      </svg>
      {p?.approx && <div className="absolute bottom-2 left-2 rounded bg-black/70 px-2 py-0.5 text-[10px] text-muted-foreground">Posição aproximada (centro do estado)</div>}
    </div>
  );
};
